import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDDQTBnzSD7xSHgvebJ6MthDfFTAAGppFo",
  authDomain: "evoq-travel-craft.firebaseapp.com",
  projectId: "evoq-travel-craft",
  storageBucket: "evoq-travel-craft.firebasestorage.app",
  messagingSenderId: "14140141147",
  appId: "1:14140141147:web:790728679366acb2eb597e",
  measurementId: "G-K3M3TP711L",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { app, auth };